import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { AssetAggregateFieldInfo } from '../../types/generated/AssetAggregateFieldInfo.schema';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateCollectionFieldsCardMutationVariables = Types.Exact<{
  collectionId: Types.Scalars['ID']['input'];
  fieldsCard?: Types.InputMaybe<Array<Types.CollectionFieldInput>>;
}>;


export type UpdateCollectionFieldsCardMutation = { __typename?: 'Mutation', updateCollection?: { __typename?: 'UpdateCollectionPayload', collection?: { __typename?: 'Collection', id: string, fieldsCard?: { __typename?: 'CollectionFieldConnection', totalCount: number, nodes: Array<{ __typename?: 'CollectionField', isEditable?: boolean | null, isFrozen?: boolean | null, isVisible?: boolean | null, width?: number | null, fieldDefinition?: { __typename?: 'ProjectFieldDefinition', fieldType: Types.FieldTypeEnum, id: string, isDefaultField?: boolean | null, isSortable?: boolean | null, isSystemField: boolean, name: string, configuration?: { __typename?: 'DateFieldConfiguration', displayFormat?: Types.DisplayFormatEnum | null, displayTimezone?: boolean | null, includeTime?: boolean | null, timeFormat?: Types.TimeFormatEnum | null } | { __typename?: 'NumberFieldConfiguration', scale?: number | null } | { __typename?: 'RatingFieldConfiguration', color?: string | null, maxValue: number, style?: Types.RatingStyleEnum | null } | { __typename?: 'SelectFieldConfiguration', options: Array<{ __typename?: 'SelectOption', color?: string | null, displayName: string, id: string }> } | { __typename?: 'ToggleFieldConfiguration', color?: string | null } | { __typename?: 'UserFieldConfiguration', memberOptionsType: Types.MemberOptionsTypeEnum, notifyMembers: boolean } | { __typename?: 'UsersFieldConfiguration', memberOptionsType: Types.MemberOptionsTypeEnum, notifyMembers: boolean, selectType: Types.MemberSelectTypeEnum } | null } | null } | null> } | null } | null } | null };


export const UpdateCollectionFieldsCard = /*#__PURE__*/ gql`
    mutation UpdateCollectionFieldsCard($collectionId: ID!, $fieldsCard: [CollectionFieldInput!]) {
  updateCollection(input: {collectionId: $collectionId, fieldsCard: $fieldsCard}) {
    collection {
      id
      fieldsCard(page: {first: 100}) {
        nodes {
          ...AssetAggregateFieldInfo
        }
        totalCount
      }
    }
  }
}
    ${AssetAggregateFieldInfo}` as unknown as DocumentNode<UpdateCollectionFieldsCardMutation, UpdateCollectionFieldsCardMutationVariables>;

          

          export const useUpdateCollectionFieldsCardMutation = (options?:MutationHookOptions<UpdateCollectionFieldsCardMutation, UpdateCollectionFieldsCardMutationVariables>) => useMutation(UpdateCollectionFieldsCard, options);
          

          export type UpdateCollectionFieldsCardMutationOptions = MutationHookOptions<UpdateCollectionFieldsCardMutation, UpdateCollectionFieldsCardMutationVariables>;

          

          export type UpdateCollectionFieldsCardMutationResult = ReturnType<typeof useUpdateCollectionFieldsCardMutation>[1];

          
